module.exports = __webpack_public_path__ + "img/icon-nursing-inactive.8bf780d0.png";